(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compare-features"] && !Shopify.designMode) return;
  try {
    
  function snugwellCompareSizeGroup(size) {
    const normalized = String(size || '').trim().toUpperCase().replace(/\s+/g, '');
    if (normalized === 'S' || normalized === 'M') return 'standard';
    if (normalized === 'L' || normalized === 'XL') return 'full';
    if (normalized === '2XL' || normalized === 'XXL' || normalized === '3XL' || normalized === '4XL') return 'extended';
    return '';
  }

  function snugwellSelectedSize(table, explicitSize) {
    if (explicitSize) return explicitSize;

    const mappings = Array.from(table.querySelectorAll('[data-variant-id]'));
    const variantInputs = Array.from(document.querySelectorAll('form[action*="/cart/add"] input[name="id"]'));
    for (const input of variantInputs) {
      const match = mappings.find((item) => item.dataset.variantId === input.value);
      if (match) return match.dataset.size;
    }

    const checkedSize = Array.from(document.querySelectorAll('input:checked')).find((input) =>
      String(input.name || '').toLowerCase().includes('size')
    );
    if (checkedSize) return checkedSize.value;

    const sizeSelect = Array.from(document.querySelectorAll('select')).find((select) =>
      String(select.name || '').toLowerCase().includes('size')
    );
    return sizeSelect ? sizeSelect.value : '';
  }

  function snugwellUpdateCompareSizeHighlights(explicitSize) {
    document.querySelectorAll('[data-compare-size-table]').forEach((table) => {
      const group = snugwellCompareSizeGroup(snugwellSelectedSize(table, explicitSize));
      if (!group) return;

      table.querySelectorAll('[data-compare-size-group]').forEach((badge) => {
        badge.className =
          badge.dataset.compareSizeGroup === group
            ? badge.dataset.activeClass
            : badge.dataset.normalClass;
      });
    });
  }

  if (!window.__snugwellCompareSizeHighlightBound) {
    window.__snugwellCompareSizeHighlightBound = true;

    document.addEventListener('change', (event) => {
      const name = String(event.target && event.target.name || '').toLowerCase();
      const explicitSize = name.includes('size') ? event.target.value : '';
      requestAnimationFrame(() => {
        snugwellUpdateCompareSizeHighlights(explicitSize);
        setTimeout(() => snugwellUpdateCompareSizeHighlights(explicitSize), 60);
      });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => snugwellUpdateCompareSizeHighlights());
    } else {
      snugwellUpdateCompareSizeHighlights();
    }
  }

  } catch(e) { console.error(e); }
})();
})();
